import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitialFormComponent } from './initial-form.component';
import {
  FormModule,
  ButtonModule,
  SelectModule,
  CheckboxModule,
  InputModule,
  StorageService,
  STORAGE_PREFIX,
  RangeSliderModule,
  DetectDeviceService
} from '@apps/ui';

@NgModule({
  declarations: [InitialFormComponent],
  exports: [InitialFormComponent],
  imports: [
    CommonModule,
    FormModule,
    ButtonModule,
    SelectModule,
    CheckboxModule,
    InputModule,
    RangeSliderModule,
    CheckboxModule
  ],
  providers: [
    StorageService,
    DetectDeviceService,
    { provide: STORAGE_PREFIX, useFactory: () => 'sc' }
  ]
})
export class InitialFormModule {}
